import React, { useEffect, useState } from 'react';
import './Style.css';

const Rooms = () => {
  const [images, setImages] = useState([]);

  useEffect(() => {
    fetch('/Data/Rooms.json')
      .then((res) => res.json())
      .then((data) => setImages(data))
      .catch((err) => console.error('Error loading JSON:', err));
  }, []);

  return (
    <div>
       <div style={{ position: 'relative', width: '100%', height: '70vh' }}>
        <img
          src="/image/bg4.jpg"
          alt="Hotel"
          className="img-fluid"
          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
        />
        
        {/* Black semi-transparent overlay */}
        <div style={{
          position: 'absolute',
          top: 0, left: 0,
          width: '100%', height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.5)', 
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          color: 'white',
          fontSize: '3rem',
          fontWeight: 'bold'
        }}>
          
        Rooms
      </div>
    </div>

       <section className="py-5" style={{ backgroundColor: '#f8f9fa' }}>

          <div className="container">
            <p>  HOTELER LUXURY ROOMS</p>
            <h1 className='pb-5'><strong>Luxury Rooms & Suites</strong></h1>
             <div className="d-flex flex-wrap justify-content-between gap-3">
                {images.map((image) => (
               <div key={image.id} className="image-container">
                 <img
                    src={image.image}
                    alt={image.title}
                    className="gallery-image"
                  />
                  <div className="overlay-title">{image.title}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
    </div>

   
  );
};

export default Rooms
